

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import {getFullReportName} from '../utilities/report-helpers';

import Button from './Button'

const PartnerInsightsReportEditor = ({
  reports,
  organisations,
  subcategories,
  index,
  selectedReport,
  editedReport,
  handleSelectReport,
  handleSetReportOrganisations,
  handleSetReportSubcategories,
  handleCancelEditingButton,
  handleSaveReportPermissionsButton,
}) => (
  <div className="PartnerInsights_edit-reports">
    <div className="PartnerInsights_edit-reports_wrapper">
      <div className="PartnerInsights_edit-reports_list">
        <fieldset>
          <legend className="PartnerInsights_edit-reports_legend">
            Reports
          </legend>
          <ul className="PartnerInsights_edit-reports_list_ul">
              <li
                className="PartnerInsights_edit-reports_list_li"
                key={reports[0].name}
              >
                <label
                  className="PartnerInsights_edit-reports_list_label"
                  htmlFor={`report-id-${reports[0].name}`}
                >
                  <input
                    className="PartnerInsights_edit-reports_list_radio"
                    type="radio"
                    name="report"
                    id={`report-id-${reports[0].name}`}
                    value="in"
                    checked={0 === selectedReport}
                    onChange={() =>
                      handleSelectReport(reports[0], 0)
                    }
                  />
                  <span className="PartnerInsights_edit-reports_list_title">
                    {getFullReportName(reports[0].name)}
                  </span>
                </label>
              </li>
          </ul>
        </fieldset>
      </div>
      <div className="PartnerInsights_edit-reports_edit">
        <label
          className="PartnerInsights_account-owner-select-label"
          htmlFor="PartnerInsights-search-organisations"
        >
          Search Organisations
        </label>
        <Select
          id="PartnerInsights-search-organisations"
          value={editedReport.organisation}
          onChange={handleSetReportOrganisations}
          options={organisations}
          isMulti
        />
        <br />
        <label
          className="PartnerInsights_account-owner-select-label"
          htmlFor="PartnerInsights-search-subcategories"
        >
          Search Subcategories
        </label>
        <Select
          id="PartnerInsights-search-subcategories"
          value={editedReport.subcategories}
          onChange={handleSetReportSubcategories}
          options={subcategories}
          isMulti
        />
      </div>
    </div>
    <div className="PartnerInsights_button_wrapper">
      <Button
        label="Cancel"
        onClick={handleCancelEditingButton}
        color="secondary"
        />{' '}
      <Button
        label="Save"
        onClick={() => handleSaveReportPermissionsButton(index)}
      />
    </div>
  </div>
);

PartnerInsightsReportEditor.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object).isRequired,
  organisations: PropTypes.arrayOf(PropTypes.object).isRequired,
  subcategories: PropTypes.arrayOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  selectedReport: PropTypes.number.isRequired,
  editedReport: PropTypes.object.isRequired, // eslint-disable-line
  handleSelectReport: PropTypes.func.isRequired,
  handleSetReportOrganisations: PropTypes.func.isRequired,
  handleSetReportSubcategories: PropTypes.func.isRequired,
  handleCancelEditingButton: PropTypes.func.isRequired,
  handleSaveReportPermissionsButton: PropTypes.func.isRequired,
};

export default PartnerInsightsReportEditor;
